/* ==========================================================================
   TNF · Eigenstaendige Produktseite
   --------------------------------------------------------------------------
   Haelt vier Dinge in Gang: Galerie, Aufklapper, Variantenwechsel und die
   Leiste am unteren Rand. Bewusst ohne Halos variant-selects - die Seite soll
   auch dann stehen, wenn am Theme geschraubt wird.

   Der Warenkorb laeuft weiter ueber Halo: die Schaltflaeche traegt
   data-btn-addToCart, damit greift dessen Ajax-Logik samt Drawer.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-tnf-product]');
  if (!root) return;

  var DATA = { variants: [], delivery: '18-21' };
  var raw = root.querySelector('[data-tnf-product-json]');
  if (raw) {
    try {
      DATA = JSON.parse(raw.textContent);
    } catch (e) {
      /* Ohne Variantendaten bleibt die Seite bedienbar, nur ohne Umschalten. */
    }
  }

  var $ = function (sel) { return root.querySelector(sel); };
  var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

  /* ---------------------------------------------------------------- Galerie

     Drei Dinge: Vorschaubild anklicken, mit den Pfeilen am grossen Bild
     weiterblaettern, und den Streifen links hoch- und runterschieben.
     Alles haengt an derselben Liste, damit die Markierung nie auseinander
     laeuft - egal, ueber welchen Weg gewechselt wurde. */
  var main = $('#tnfpMain');
  var thumbs = $$('[data-tnf-thumb]');
  var vp = $('[data-tnf-rail-vp]');
  var rail = $('.tnfp-rail');
  var count = $('[data-tnf-count]');
  var pos = 0;

  for (var t = 0; t < thumbs.length; t++) {
    if (thumbs[t].classList.contains('is-on')) { pos = t; break; }
  }

  function zeige(i, scrollen) {
    if (!thumbs.length) return;
    /* Rundlauf: hinter dem letzten Bild kommt wieder das erste. Wer sich
       durchklickt, laeuft sonst gegen eine Wand. */
    if (i < 0) i = thumbs.length - 1;
    if (i >= thumbs.length) i = 0;
    pos = i;

    var btn = thumbs[i];
    if (main && btn.dataset.src) main.setAttribute('src', btn.dataset.src);
    thumbs.forEach(function (b) { b.classList.remove('is-on'); });
    btn.classList.add('is-on');
    if (count) count.textContent = (i + 1) + ' / ' + thumbs.length;

    /* Das aktive Vorschaubild in den sichtbaren Bereich holen - sonst
       markiert man beim Blaettern etwas, das man nicht sieht. */
    if (scrollen && vp) {
      var b = btn.getBoundingClientRect();
      var v = vp.getBoundingClientRect();
      if (b.top < v.top) vp.scrollTop -= (v.top - b.top);
      else if (b.bottom > v.bottom) vp.scrollTop += (b.bottom - v.bottom);
    }
  }

  thumbs.forEach(function (btn, i) {
    btn.addEventListener('click', function () { zeige(i, false); });
  });

  $$('[data-tnf-step]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      zeige(pos + parseInt(btn.dataset.tnfStep, 10), true);
    });
  });

  /* Pfeile an der Schiene. Geschoben wird um die Hoehe eines Vorschaubildes
     plus Abstand - so rastet der Streifen sauber ein. */
  function schrittHoehe() {
    if (thumbs.length < 2) return 100;
    var a = thumbs[0].getBoundingClientRect();
    var b = thumbs[1].getBoundingClientRect();
    return Math.round(b.top - a.top) || Math.round(a.height) + 10;
  }

  $$('[data-tnf-rail]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!vp) return;
      vp.scrollTop += parseInt(btn.dataset.tnfRail, 10) * schrittHoehe();
    });
  });

  /* Passt alles hinein, verschwinden die Pfeile. Sonst zeigen sie an, ob es
     nach oben oder unten noch weitergeht. */
  function pruefePfeile() {
    if (!vp || !rail) return;
    var passt = vp.scrollHeight <= vp.clientHeight + 2;
    rail.classList.toggle('is-fit', passt);
    var hoch = rail.querySelector('[data-tnf-rail="-1"]');
    var runter = rail.querySelector('[data-tnf-rail="1"]');
    if (hoch) hoch.disabled = vp.scrollTop <= 0;
    if (runter) runter.disabled = vp.scrollTop + vp.clientHeight >= vp.scrollHeight - 2;
  }

  if (vp) {
    vp.addEventListener('scroll', pruefePfeile);
    window.addEventListener('resize', pruefePfeile);
    /* Erst wenn das grosse Bild seine Hoehe kennt, steht auch die der
       Schiene fest - deshalb zusaetzlich nach dem Laden messen. */
    window.addEventListener('load', pruefePfeile);
    pruefePfeile();
  }
  if (count && thumbs.length) count.textContent = (pos + 1) + ' / ' + thumbs.length;

  /* ------------------------------------------------------------ Aufklapper */
  $$('.tnfp-acc-h').forEach(function (head) {
    head.addEventListener('click', function () {
      var item = head.parentElement;
      var open = item.classList.toggle('is-open');
      head.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ----------------------------------------------------------------- Menge */
  var qtyInput = $('[data-tnf-qty-input]');
  $$('[data-tnf-qty]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!qtyInput) return;
      var next = (parseInt(qtyInput.value, 10) || 1) + parseInt(btn.dataset.tnfQty, 10);
      qtyInput.value = next < 1 ? 1 : next;
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* ------------------------------------------------------------- Varianten */
  var selects = $$('[data-tnf-option]');
  var hidden = $('[data-tnf-variant-id]');

  function chosen() {
    return selects.map(function (s) { return s.value; });
  }

  function findVariant(values) {
    for (var i = 0; i < DATA.variants.length; i++) {
      var v = DATA.variants[i];
      var hit = true;
      for (var k = 0; k < values.length; k++) {
        if (v.options[k] !== values[k]) { hit = false; break; }
      }
      if (hit) return v;
    }
    return null;
  }

  function money(text) { return text || ''; }

  function stockState(v) {
    if (!v || !v.available) return 'out';
    if (!v.managed) return 'in';
    return v.qty > 0 ? 'in' : 'slow';
  }

  var STOCK_TEXT = {
    in: '<strong>Auf Lager, sofort versandfertig.</strong> Lieferzeit 3-5 Werktage. Versand aus Essen.',
    slow: '<strong>Bestellt, unterwegs ins Lager.</strong> Lieferzeit {d} Werktage. Versand aus Essen.',
    out: '<strong>Zurzeit nicht verfügbar.</strong> Schreib uns, wir sagen dir, wann das Teil wieder da ist.'
  };

  function paintStock(v) {
    var box = $('.tnfp-stock .tnf-stock');
    if (!box) return;
    var state = stockState(v);
    box.classList.remove('tnf-stock--slow', 'tnf-stock--out');
    if (state === 'slow') box.classList.add('tnf-stock--slow');
    if (state === 'out') box.classList.add('tnf-stock--out');
    var span = box.querySelector('span');
    if (span) span.innerHTML = STOCK_TEXT[state].replace('{d}', DATA.delivery || '18-21');
  }

  function paintPrice(v) {
    var now = $('[data-tnf-price-now]');
    var was = $('[data-tnf-price-was]');
    var off = $('[data-tnf-price-off]');
    if (now) now.textContent = money(v.priceText);
    var onSale = v.compare > v.price;
    if (was) {
      was.textContent = onSale ? money(v.compareText) : '';
      was.hidden = !onSale;
    }
    if (off) {
      off.innerHTML = onSale ? '&minus;&nbsp;' + Math.round(((v.compare - v.price) / v.compare) * 100) + '&nbsp;%' : '';
      off.hidden = !onSale;
    }
  }

  function paintSubtotal(v) {
    var el = $('[data-tnf-subtotal]');
    if (el) el.textContent = money(v.priceText);
  }

  function paintButton(v) {
    var btn = $('[data-tnf-atc]');
    var label = $('[data-tnf-atc-text]');
    if (!btn) return;
    btn.disabled = !v.available;
    if (label) label.textContent = v.available ? 'In den Warenkorb' : 'Ausverkauft';
  }

  function paintSticky(v) {
    var p = $('[data-tnf-sticky-price]');
    var o = $('[data-tnf-sticky-options]');
    if (p) p.textContent = money(v.priceText);
    if (o) o.textContent = v.title;
  }

  /* ----------------------------------------------------- Bild zur Variante

     Haengt an der gewaehlten Variante im Shopify-Admin ein eigenes Bild,
     zeigt die Galerie es beim Umschalten. Ist keins hinterlegt, bleibt das
     aktuelle Bild stehen - ein Sprung auf irgendein anderes Foto waere
     verwirrender als gar keine Bewegung.

     Der Kasten ist quadratisch und das Bild steht auf object-fit:contain,
     deshalb springt beim Wechsel nichts im Seitenaufbau. */
  function paintImage(v) {
    if (!main || !v.img) return;
    if (main.getAttribute('src') !== v.img) main.setAttribute('src', v.img);

    /* Ueber zeige() gehen, damit Markierung, Zaehler und Streifen mitziehen. */
    if (!v.mediaId) return;
    for (var i = 0; i < thumbs.length; i++) {
      if (String(thumbs[i].dataset.mediaId) === String(v.mediaId)) { zeige(i, true); return; }
    }
  }

  function apply() {
    var values = chosen();
    selects.forEach(function (s) {
      var out = root.querySelector('[data-tnf-option-selected="' + s.dataset.tnfOption + '"]');
      if (out) out.textContent = s.value;
    });

    var v = findVariant(values);
    if (!v) return;
    if (hidden) hidden.value = v.id;
    paintPrice(v);
    paintSubtotal(v);
    paintStock(v);
    paintButton(v);
    paintSticky(v);
    paintImage(v);

    // Fahrzeugauswahl und Zusatzfelder haengen teils an der Variante.
    document.dispatchEvent(new CustomEvent('tnf:variant-change', { detail: v }));

    if (history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url.toString());
    }
  }

  selects.forEach(function (s) { s.addEventListener('change', apply); });

  /* ------------------------------------------- Leiste am unteren Rand */
  var sticky = $('[data-tnf-sticky]');
  var buyrow = $('.tnfp-buyrow');
  if (sticky && buyrow && 'IntersectionObserver' in window) {
    new IntersectionObserver(
      function (entries) {
        sticky.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0;
      },
      { rootMargin: '0px 0px -100% 0px' }
    ).observe(buyrow);
  }

  var stickyAdd = $('[data-tnf-sticky-add]');
  if (stickyAdd) {
    stickyAdd.addEventListener('click', function () {
      var real = $('[data-tnf-atc]');
      if (real && !real.disabled) real.click();
    });
  }

  /* -------------------------------------------------- Beschreibung kuerzen */
  var more = $('[data-tnf-more]');
  if (more) {
    var inner = more.querySelector('.tnfp-more-in');
    var moreBtn = more.querySelector('[data-tnf-more-btn]');
    // Nur kuerzen, wenn es wirklich etwas zu kuerzen gibt.
    if (inner && moreBtn && inner.scrollHeight > 300) {
      more.classList.add('is-clamped');
      moreBtn.addEventListener('click', function () {
        var open = more.classList.toggle('is-open');
        moreBtn.textContent = open ? 'Weniger anzeigen' : 'Weiterlesen';
      });
    } else if (moreBtn) {
      moreBtn.remove();
    }
  }

  /* ----------------------------------------------------- Set in den Korb
     Jede Position bekommt die Zeilen-Eigenschaft _tnf_set mit der Kennung
     dieses Sets. Genau daran erkennt die Shopify Discount Function spaeter,
     welche Zeilen zum Set gehoeren - und rechnet nur auf diesen. Legt der
     Kunde danach noch ein Teil dazu, traegt dessen Zeile die Markierung
     nicht und bleibt zum vollen Preis stehen.

     Der Unterstrich am Anfang ist kein Zufall: Shopify blendet Eigenschaften,
     die so beginnen, im Warenkorb und an der Kasse aus. Der Kunde sieht die
     Markierung also nicht, die Function schon.

     Weil sich die Eigenschaften unterscheiden, legt Shopify eine eigene
     Warenkorbzeile an - auch wenn dieselbe Variante schon ohne Markierung
     im Korb liegt. Das ist gewollt: sonst wuerde die Markierung nachtraeglich
     auf einen Artikel abfaerben, der sie nicht verdient hat. */
  var bundleBtn = document.querySelector('[data-tnf-bundle-add]');
  if (bundleBtn) {
    bundleBtn.addEventListener('click', function () {
      var ids = (bundleBtn.dataset.ids || '').split(',').filter(Boolean);
      if (ids.length < 2) return;
      var setKey = (bundleBtn.dataset.set || '').trim() || 'set';

      bundleBtn.disabled = true;
      var before = bundleBtn.textContent;
      bundleBtn.textContent = 'Wird hinzugefügt …';

      var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      var items = ids.map(function (id) {
        return { id: Number(id), quantity: 1, properties: { _tnf_set: setKey } };
      });

      /* Hinzufuegen und Schubfach oeffnen macht tnf-cart-open.js. Der
         frühere Weg ueber halo.updateSidebarCart lief ins Leere - "halo"
         ist von aussen nicht erreichbar, das Schubfach blieb deshalb zu. */
      if (typeof window.tnfAddAndOpenCart !== 'function') {
        window.location.href = shopRoot + 'cart';
        return;
      }

      window.tnfAddAndOpenCart(items)
        .then(function () {
          bundleBtn.disabled = false;
          bundleBtn.textContent = before;
        })
        .catch(function () {
          bundleBtn.disabled = false;
          bundleBtn.textContent = 'Hat nicht geklappt, bitte nochmal';
        });
    });
  }

  apply();
})();
